module.exports = __webpack_public_path__ + "media/public/img/affiliate-image-default-0891a2c54abe79bfc0c87a6c64359654.jpg";